// https://en.wikipedia.org/wiki/Rounding#Round_half_to_even
export const roundHalfToEven = (number: number) =>
  number - Math.floor(number) === 0.5 ? Math.round(number / 2) * 2 : Math.round(number)

export const roundToHundredth = (number: number | string) =>
  roundHalfToEven((typeof number === 'number' ? number : parseFloat(number)) * 100) / 100

export const roundToThousandth = (number: number | string) =>
  roundHalfToEven((typeof number === 'number' ? number : parseFloat(number)) * 1000) / 1000

export const displayNumberAsPrice = (number: number | string) => roundToHundredth(number).toFixed(2)
